import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getUsuariosTree,
  getUsuarios,
  insertUsuario,
  updateUsuario,
  deleteUsuario,
  getUsuarioById,
  patchUsuario,
  getUsuariosTreeFiltered,
  getPermisosMenuKeyUsuario,
  getUsuarioPerfilById,
  getUsuarioStockManager,
} from 'services/usuario'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
import history from '../../history'

export function* GET_USUARIOS_TREE() {
  try {
    const usuariosData = yield call(getUsuariosTree)
    if (usuariosData.ok) {
      yield put({
        type: actions.USUARIOS_TREE_LOAD_SUCCEEDED,
        payload: usuariosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Usuarios')
      put({
        type: actions.USUARIOS_TREE_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIOS_TREE_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_USUARIOS_TREE_FILTERED(action) {
  try {
    const usuariosData = yield call(getUsuariosTreeFiltered, action.payload)
    if (usuariosData.ok) {
      yield put({
        type: actions.USUARIOS_TREE_LOAD_SUCCEEDED_FILTERED,
        payload: usuariosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Usuarios')
      put({
        type: actions.USUARIOS_TREE_LOAD_FILED_FILTERED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIOS_TREE_LOAD_FILED_FILTERED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_USUARIOS() {
  try {
    const usuariosData = yield call(getUsuarios)
    if (usuariosData.ok) {
      yield put({
        type: actions.USUARIOS_LOAD_SUCCEEDED,
        payload: usuariosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Usuarios')
      put({
        type: actions.USUARIOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_USUARIO(action) {
  try {
    const usuarioObj = yield call(insertUsuario, action.payload)
    if (usuarioObj.ok) {
      putMessage(messageType.SUCCESS, 'Usuario creado correctamente')
      history.push('/usuariosAdmin/usuarios/list')

      yield put({
        type: actions.USUARIO_INSERT_SUCCEEDED,
        payload: usuarioObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Usuario')
      yield put({
        type: actions.USUARIO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Usuario')
    yield all([
      put({
        type: actions.USUARIO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_USUARIO(action) {
  try {
    const usuarioObj = yield call(updateUsuario, action.payload)
    if (usuarioObj.ok) {
      putMessage(messageType.SUCCESS, 'Usuario modificado correctamente')
      history.push('/usuariosAdmin/usuarios/list')
      yield put({
        type: actions.USUARIO_UPDATE_SUCCEEDED,
        payload: usuarioObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Usuario')
      yield put({
        type: actions.USUARIO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Usuario')
    yield all([
      put({
        type: actions.USUARIO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* PATCH_USUARIO(action) {
  try {
    const usuarioObj = yield call(patchUsuario, action.id, action.payload)
    if (usuarioObj.ok) {
      if (!action.noNotificar) {
        putMessage(messageType.SUCCESS, 'Usuario modificado correctamente')
      }
      yield put({
        type: actions.USUARIO_PATCH_SUCCEEDED,
        payload: usuarioObj.data,
      })
      // 👇 Lanzamos el evento para refrescar el usuario
      yield put({
        type: actions.USUARIO_LOAD_BY_ID_REQUESTED,
        payload: action.id,
      })
    } else {
      if (!action.noNotificar) {
        putMessage(messageType.ERROR, 'Error al modificar Usuario')
      }
      yield put({
        type: actions.USUARIO_PATCH_FILED,
      })
    }
  } catch (e) {
    if (!action.noNotificar) {
      putMessage(messageType.ERROR, 'Error al modificar Usuario')
    }
    yield all([
      put({
        type: actions.USUARIO_PATCH_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_USUARIO(action) {
  try {
    const usuarioResult = yield call(deleteUsuario, action.payload)
    if (usuarioResult.ok) {
      putMessage(messageType.SUCCESS, 'Usuario eliminado correctamente')
      yield put({
        type: actions.USUARIO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Usuario')
      yield put({
        type: actions.USUARIO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Usuario')
    yield all([
      put({
        type: actions.USUARIO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_USUARIO_BY_ID(action) {
  try {
    const usuarioData = yield call(getUsuarioById, action.payload)
    if (usuarioData.ok) {
      yield put({
        type: actions.USUARIO_LOAD_BY_ID_SUCCEEDED,
        payload: usuarioData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Usuario')
      put({
        type: actions.USUARIO_LOAD_BY_ID_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIO_LOAD_BY_ID_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_USUARIO_PERFIL_BY_ID(action) {
  try {
    const usuarioData = yield call(getUsuarioPerfilById, action.payload)
    if (usuarioData.ok) {
      yield put({
        type: actions.USUARIO_LOAD_BY_ID_PERFIL_SUCCEEDED,
        payload: usuarioData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Usuario')
      put({
        type: actions.USUARIO_LOAD_BY_ID_PERFIL_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIO_LOAD_BY_ID_PERFIL_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_USUARIO_PEMISOS_MENUKEYS_BY_ID(action) {
  try {
    const usuarioData = yield call(getPermisosMenuKeyUsuario, action.payload)
    if (usuarioData.ok) {
      yield put({
        type: actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_SUCCEEDED,
        payload: usuarioData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los permisos del usuario')
      put({
        type: actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_USUARIO_STOCK_MANAGER(action) {
  try {
    const usuarioData = yield call(getUsuarioStockManager, action.payload)
    if (usuarioData.ok) {
      yield put({
        type: actions.USUARIO_LOAD_STOCK_MANAGER_SUCCEEDED,
        payload: usuarioData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Usuario')
      put({
        type: actions.USUARIO_LOAD_STOCK_MANAGER_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.USUARIO_LOAD_STOCK_MANAGER_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.USUARIOS_TREE_LOAD_REQUESTED, GET_USUARIOS_TREE),
    takeEvery(actions.USUARIOS_TREE_LOAD_REQUESTED_FILTERED, GET_USUARIOS_TREE_FILTERED),
    takeEvery(actions.USUARIOS_LOAD_REQUESTED, GET_USUARIOS),
    takeEvery(actions.USUARIO_LOAD_BY_ID_REQUESTED, GET_USUARIO_BY_ID),
    takeEvery(actions.USUARIO_INSERT_REQUESTED, INSERT_USUARIO),
    takeEvery(actions.USUARIO_UPDATE_REQUESTED, UPDATE_USUARIO),
    takeEvery(actions.USUARIO_DELETE_REQUESTED, DELETE_USUARIO),
    takeEvery(actions.USUARIO_PATCH_REQUESTED, PATCH_USUARIO),
    takeEvery(actions.USUARIO_LOAD_BY_ID_PERFIL_REQUESTED, GET_USUARIO_PERFIL_BY_ID),
    takeEvery(actions.USUARIO_LOAD_STOCK_MANAGER_REQUESTED, GET_USUARIO_STOCK_MANAGER),
    takeEvery(
      actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_REQUESTED,
      GET_USUARIO_PEMISOS_MENUKEYS_BY_ID,
    ),
  ])
}
